import { ExpandMore } from "@mui/icons-material";
import {
	Box,
	Collapse,
	Fab,
	Grid,
	Paper,
	Stack,
	Typography,
} from "@mui/material";
import { useState } from "react";

type ClientInfoCardProps = {
	name: string;
	birthDate?: string;
	email?: string;
	phone?: string;
};

export const ClientInfoCard = ({
	name,
	birthDate,
	email,
	phone,
}: ClientInfoCardProps) => {
	const [expanded, setExpanded] = useState(false);

	const hasDetails = birthDate || email || phone;

	return (
		<Paper
			elevation={0}
			sx={{
				border: "1px solid #E9EAEB",
				borderRadius: 2,
				overflow: "visible",
				position: "relative",
			}}
		>
			<Stack
				direction="row"
				alignItems="center"
				justifyContent="space-between"
				sx={{ px: 3, py: 2 }}
			>
				<Typography variant="h2" component="h1">
					{name}
				</Typography>
			</Stack>
			{hasDetails && (
				<Collapse in={expanded}>
					<Box
						sx={{
							px: 3,
							py: 2,
							borderTop: "1px solid #E9EAEB",
							backgroundColor: "#FAFAFA",
						}}
					>
						<Grid container spacing={3}>
							{birthDate && (
								<Grid size={{ xs: 12, sm: 4 }}>
									<Typography
										variant="caption"
										color="text.secondary"
										component="div"
									>
										Datum narození
									</Typography>
									<Typography variant="body2">{birthDate}</Typography>
								</Grid>
							)}
							{email && (
								<Grid size={{ xs: 12, sm: 4 }}>
									<Typography
										variant="caption"
										color="text.secondary"
										component="div"
									>
										E-mail
									</Typography>
									<Typography variant="body2">{email}</Typography>
								</Grid>
							)}
							{phone && (
								<Grid size={{ xs: 12, sm: 4 }}>
									<Typography
										variant="caption"
										color="text.secondary"
										component="div"
									>
										Telefon
									</Typography>
									<Typography variant="body2">{phone}</Typography>
								</Grid>
							)}
						</Grid>
					</Box>
				</Collapse>
			)}
			{hasDetails && (
				<Box
					sx={{
						position: "absolute",
						bottom: 0,
						left: "50%",
						transform: "translate(-50%, 50%)",
						zIndex: 1,
					}}
				>
					<Fab
						size="small"
						onClick={() => setExpanded(!expanded)}
						aria-label={expanded ? "Skrýt detaily" : "Zobrazit detaily"}
						sx={{
							width: 32,
							height: 32,
							minHeight: 32,
							backgroundColor: "#535862",
							color: "#FFFFFF",
							boxShadow: "none",
							"&:hover": {
								backgroundColor: "#414651",
							},
						}}
					>
						<ExpandMore
							sx={{
								fontSize: 20,
								transform: expanded ? "rotate(180deg)" : "rotate(0deg)",
								transition: "transform 0.2s ease-in-out",
							}}
						/>
					</Fab>
				</Box>
			)}
		</Paper>
	);
};
